import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyActions from "./StickyActions";
import SmoothScroll from "./SmoothScroll";
import PageTransition from "./PageTransition";

export default function Layout() {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-obsidian text-white">
        <Navbar />
        <main className="pb-16 lg:pb-0">
          <PageTransition>
            <Outlet />
          </PageTransition>
        </main>
        <Footer />
        <StickyActions />
      </div>
    </SmoothScroll>
  );
}
